import api from "./api";

class CompanyInfoService {
    get() {
        return api.get("/api/company-info/");
    }
}

export default new CompanyInfoService();
